var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.795,
    height: 19.732,
    viewBox: "0 0 19.795 19.732",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M720.533,738.67a.534.534,0,0,1-.377-.911l17.6-17.6a.533.533,0,0,1,.754.754l-17.6,17.6a.533.533,0,0,1-.377.156",
    transform: "translate(-719.437 -719.438)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M738.136,738.67a.532.532,0,0,1-.377-.156l-17.6-17.6a.533.533,0,0,1,.754-.754l8.8,8.8,8.806,8.806a.534.534,0,0,1-.377.911",
    transform: "translate(-719.437 -719.438)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkIcon);
export default __webpack_public_path__ + "static/media/x-mark-icon.33db45d459bb66496eb6c0f857811e9f.svg";
export { ForwardRef as ReactComponent };